export default function (value, max) {
	if (!value || typeof value !== 'string' || value.length <= max) { return value }
	return `${value.substr(0, max)}...`
}
